import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { TagEvent } from 'tag/ts/tag/events/TagEvent';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
export class VideoAPIUtilities extends AbstractTagClass {
    constructor(argument) {
        super({
            ...argument,
            name: 'VideoAPIUtilities'
        });
    }
    allowedToLoadVideo = () => {
        let allowed = true;
        switch (this.tag?.params?.SYSTEM?.embedType) {
            case EmbedType.DESKTOP:
                this?.logger?.log('load:', 'casting:', this?.tag?.snapshot?.casting);
                allowed = !this?.tag?.snapshot?.casting;
                break;
        }
        return allowed;
    };
    clearContentProperties = () => {
        return new Promise((resolve) => {
            if (this.utils.Type.isObject(this.tag) && this.utils.Type.isObject(this.tag?.params?.CONTENT)) {
                [
                    'apiMetadata',
                    'assetURL',
                    'contentId',
                    'drm',
                    'globalResumeTime',
                    'pid'
                ].forEach((property) => {
                    this.tag.params.CONTENT[property] = undefined;
                });
                if (this.utils.Type.isObject(this.tag)
                    &&
                        this.utils.Type.isObject(this.tag?.params?.CONTEXT)) {
                    this.params.CONTEXT.metadata = undefined;
                }
                this?.logger?.log('clearContentProperties:', 'Resolve');
                resolve({ msg: `${this.name}: clearContentProperties: done!` });
            }
        });
    };
    stopPlayer = (incomingParamsVO = {}) => {
        const loggerPrefix = 'load:';
        const loggerMethodName = 'stopPlayer:';
        return new Promise((resolve) => {
            const playerStopRequestCallback = (success, result) => {
                this?.logger?.log(loggerPrefix, loggerMethodName, 'playerStopRequestCallback Success:', success, result);
                switch (success) {
                    case true:
                        this?.logger?.log(loggerPrefix, loggerMethodName, 'playerStopRequestCallback', 'dispatching', TagEvent.ON_API_LOAD_STOP_PLAYER_SUCCESS, 'with params', incomingParamsVO);
                        this.tag.dispatchTagEvent(this.tag.getTagEventVO(TagEvent.ON_API_LOAD_STOP_PLAYER_SUCCESS, this.tag, {
                            paramsVO: incomingParamsVO
                        }, this, this.name));
                        this.utils.Delay.delay().then(() => {
                            resolve({ msg: `${this.name}: stopPlayer: done!` });
                        });
                        break;
                    case false:
                        this?.logger?.warn('load: player.stop() Error:', result);
                        break;
                }
            };
            if (!this.utils.Type.isEmpty(this.tag?.snapshot?.player)) {
                this?.logger?.log(loggerPrefix, loggerMethodName, 'player is defined', 'load video during or after successful session');
                this.clearContentProperties().then(() => {
                    this.utils.Delay.delay().then(() => {
                        this?.logger?.log(loggerPrefix, loggerMethodName, 'dispatching', TagEvent.ON_API_LOAD_PLAYER_STOP_REQUEST);
                        this.tag.dispatchTagEvent(this.tag.getTagEventVO(TagEvent.ON_API_LOAD_PLAYER_STOP_REQUEST, this.tag, undefined, this, this.name));
                    }).then(() => {
                        this.utils.Delay.delay().then(() => {
                            this?.logger?.log(loggerPrefix, 'dispatching', TagEvent.ON_TAG_PLAYER_STOP_REQUEST);
                            this.tag.dispatchTagEvent(this.tag.getTagEventVO(TagEvent.ON_TAG_PLAYER_STOP_REQUEST, this.tag, {
                                eventCallback: playerStopRequestCallback
                            }, this, this.name));
                        });
                    });
                });
            }
            else {
                switch (this?.tag?.errorManager?.fatalError) {
                    case true:
                        this?.logger?.log(loggerPrefix, loggerMethodName, 'player is undefined', 'load video after fatal error.');
                        this.clearContentProperties().then(() => {
                            resolve({ msg: `${this.name}: stopPlayer: done! player is undefined => load video after fatal error` });
                        });
                        break;
                    case false:
                        this?.logger?.log(loggerPrefix, loggerMethodName, 'player is undefined', 'first video load.');
                        resolve({ msg: `${this.name}: stopPlayer: done! player is undefined => first video load` });
                        break;
                }
            }
        });
    };
}
